<template>
  <div class="rk">
    <template v-for="(r, i) in items">
      <div v-if="r === null" :key="'o' + i" class="other">{{ otherText }}</div>
      <div v-else :key="r.key || r.name" v-tip="r.tip" class="rkrow">
        <span class="rkmed" :style="{color: medal(r.rank != null ? r.rank : i)[0], background: medal(r.rank != null ? r.rank : i)[1]}">{{ (r.rank != null ? r.rank : i) + 1 }}</span>
        <span class="nm" :title="r.name">{{ r.name }}<span v-if="r.sub" style="font-weight:500;color:var(--sd-ink-4);font-size:11px"> · {{ r.sub }}</span></span>
        <span class="meter"><i :style="{width: (ready ? r.pct : 0) + '%', background: r.color || satColorPct(r.pct)}" /></span>
        <span class="pv num-ltr" :style="{color: r.color || satColorPct(r.pct)}">{{ r.pct }}%</span>
      </div>
    </template>
  </div>
</template>
<script>
/* Ranked meter rows. items: [{ name, pct, color?, sub?, tip?, rank? }] — a `null` item renders the "… n more" divider. */
import { satColorPct } from '../lib/format.js'
export default {
  name: 'SdMeterRows',
  props: { items: { type: Array, default: () => [] }, medals: Boolean, otherText: String, animate: { type: Boolean, default: true } },
  data: () => ({ ready: false }),
  mounted() { if (this.animate) requestAnimationFrame(() => requestAnimationFrame(() => { this.ready = true })); else this.ready = true },
  methods: {
    satColorPct,
    medal(i) {
      if (!this.medals) return ['var(--sd-ink-3)', 'var(--sd-card-2)']
      if (i === 0) return ['#b68a35', 'var(--sd-gold-100)']
      if (i === 1) return ['#8b8b8b', 'color-mix(in srgb,#8b8b8b 14%,transparent)']
      if (i === 2) return ['#a06b48', 'color-mix(in srgb,#a06b48 14%,transparent)']
      return ['var(--sd-ink-3)', 'var(--sd-card-2)']
    },
  },
}
</script>
